var map = {
	"./b.png": "./src/assets/images/index/map/b.png",
	"./bz.png": "./src/assets/images/index/map/bz.png",
	"./bz1.png": "./src/assets/images/index/map/bz1.png",
	"./close.png": "./src/assets/images/index/map/close.png",
	"./ctycxc.png": "./src/assets/images/index/map/ctycxc.png",
	"./cyyc3.jpg": "./src/assets/images/index/map/cyyc3.jpg",
	"./cyyc4.jpg": "./src/assets/images/index/map/cyyc4.jpg",
	"./dt_x.png": "./src/assets/images/index/map/dt_x.png",
	"./fy.png": "./src/assets/images/index/map/fy.png",
	"./htyz10.png": "./src/assets/images/index/map/htyz10.png",
	"./htyz2.png": "./src/assets/images/index/map/htyz2.png",
	"./htzz1.png": "./src/assets/images/index/map/htzz1.png",
	"./ico_kjzx.png": "./src/assets/images/index/map/ico_kjzx.png",
	"./ico_ksl.png": "./src/assets/images/index/map/ico_ksl.png",
	"./ico_line.png": "./src/assets/images/index/map/ico_line.png",
	"./ico_sf.png": "./src/assets/images/index/map/ico_sf.png",
	"./ico_tz.png": "./src/assets/images/index/map/ico_tz.png",
	"./icon_jgc_wxz.png": "./src/assets/images/index/map/icon_jgc_wxz.png",
	"./icon_jgc_xz.png": "./src/assets/images/index/map/icon_jgc_xz.png",
	"./icon_slc_wxz.png": "./src/assets/images/index/map/icon_slc_wxz.png",
	"./icon_slc_xz.png": "./src/assets/images/index/map/icon_slc_xz.png",
	"./icon_zzc_wxz.png": "./src/assets/images/index/map/icon_zzc_wxz.png",
	"./icon_zzc_xz.png": "./src/assets/images/index/map/icon_zzc_xz.png",
	"./jd.png": "./src/assets/images/index/map/jd.png",
	"./jg1.png": "./src/assets/images/index/map/jg1.png",
	"./jpyc11.png": "./src/assets/images/index/map/jpyc11.png",
	"./jpyc8.png": "./src/assets/images/index/map/jpyc8.png",
	"./jr.png": "./src/assets/images/index/map/jr.png",
	"./jr1.png": "./src/assets/images/index/map/jr1.png",
	"./jr2.png": "./src/assets/images/index/map/jr2.png",
	"./js.png": "./src/assets/images/index/map/js.png",
	"./jt/0.png": "./src/assets/images/index/map/jt/0.png",
	"./jt/1.png": "./src/assets/images/index/map/jt/1.png",
	"./jt/10.png": "./src/assets/images/index/map/jt/10.png",
	"./jt/11.png": "./src/assets/images/index/map/jt/11.png",
	"./jt/12.png": "./src/assets/images/index/map/jt/12.png",
	"./jt/13.png": "./src/assets/images/index/map/jt/13.png",
	"./jt/14.png": "./src/assets/images/index/map/jt/14.png",
	"./jt/15.png": "./src/assets/images/index/map/jt/15.png",
	"./jt/16.png": "./src/assets/images/index/map/jt/16.png",
	"./jt/17.png": "./src/assets/images/index/map/jt/17.png",
	"./jt/18.png": "./src/assets/images/index/map/jt/18.png",
	"./jt/19.png": "./src/assets/images/index/map/jt/19.png",
	"./jt/2.png": "./src/assets/images/index/map/jt/2.png",
	"./jt/20.png": "./src/assets/images/index/map/jt/20.png",
	"./jt/21.png": "./src/assets/images/index/map/jt/21.png",
	"./jt/22.png": "./src/assets/images/index/map/jt/22.png",
	"./jt/23.png": "./src/assets/images/index/map/jt/23.png",
	"./jt/24.png": "./src/assets/images/index/map/jt/24.png",
	"./jt/3.png": "./src/assets/images/index/map/jt/3.png",
	"./jt/4.png": "./src/assets/images/index/map/jt/4.png",
	"./jt/5.png": "./src/assets/images/index/map/jt/5.png",
	"./jt/6.png": "./src/assets/images/index/map/jt/6.png",
	"./jt/7.png": "./src/assets/images/index/map/jt/7.png",
	"./jt/8.png": "./src/assets/images/index/map/jt/8.png",
	"./jt/9.png": "./src/assets/images/index/map/jt/9.png",
	"./lbyc12.png": "./src/assets/images/index/map/lbyc12.png",
	"./lbyc7.png": "./src/assets/images/index/map/lbyc7.png",
	"./ld1.png": "./src/assets/images/index/map/ld1.png",
	"./line.png": "./src/assets/images/index/map/line.png",
	"./line_map.png": "./src/assets/images/index/map/line_map.png",
	"./lzzz1.png": "./src/assets/images/index/map/lzzz1.png",
	"./pig1.png": "./src/assets/images/index/map/pig1.png",
	"./pig10.png": "./src/assets/images/index/map/pig10.png",
	"./pig2.png": "./src/assets/images/index/map/pig2.png",
	"./pig3.png": "./src/assets/images/index/map/pig3.png",
	"./pig4.png": "./src/assets/images/index/map/pig4.png",
	"./pig5.png": "./src/assets/images/index/map/pig5.png",
	"./pig6.png": "./src/assets/images/index/map/pig6.png",
	"./pig7.png": "./src/assets/images/index/map/pig7.png",
	"./pig8.png": "./src/assets/images/index/map/pig8.png",
	"./pig9.png": "./src/assets/images/index/map/pig9.png",
	"./pigc1.png": "./src/assets/images/index/map/pigc1.png",
	"./pigc2.jpg": "./src/assets/images/index/map/pigc2.jpg",
	"./plh1.png": "./src/assets/images/index/map/plh1.png",
	"./plh2.png": "./src/assets/images/index/map/plh2.png",
	"./point.png": "./src/assets/images/index/map/point.png",
	"./qxyl.png": "./src/assets/images/index/map/qxyl.png",
	"./slc.jpg": "./src/assets/images/index/map/slc.jpg",
	"./slccj.png": "./src/assets/images/index/map/slccj.png",
	"./sldx.png": "./src/assets/images/index/map/sldx.png",
	"./spjgc.png": "./src/assets/images/index/map/spjgc.png",
	"./spjgcxc.png": "./src/assets/images/index/map/spjgcxc.png",
	"./wtyc9.png": "./src/assets/images/index/map/wtyc9.png",
	"./wx.png": "./src/assets/images/index/map/wx.png",
	"./xd.png": "./src/assets/images/index/map/xd.png",
	"./ymyc6.jpg": "./src/assets/images/index/map/ymyc6.jpg",
	"./ymzxc.png": "./src/assets/images/index/map/ymzxc.png",
	"./ys.png": "./src/assets/images/index/map/ys.png",
	"./zdyx.jpg": "./src/assets/images/index/map/zdyx.jpg",
	"./zdyx1.png": "./src/assets/images/index/map/zdyx1.png",
	"./zdyx2.png": "./src/assets/images/index/map/zdyx2.png",
	"./zdyx3.png": "./src/assets/images/index/map/zdyx3.png",
	"./zdyx4.png": "./src/assets/images/index/map/zdyx4.png",
	"./zjbb5.jpg": "./src/assets/images/index/map/zjbb5.jpg",
	"./zjct2.jpg": "./src/assets/images/index/map/zjct2.jpg",
	"./zjyg1.jpg": "./src/assets/images/index/map/zjyg1.jpg",
	"./zx1.png": "./src/assets/images/index/map/zx1.png",
	"./zx10.png": "./src/assets/images/index/map/zx10.png",
	"./zx2.png": "./src/assets/images/index/map/zx2.png",
	"./zx3.png": "./src/assets/images/index/map/zx3.png",
	"./zx4.png": "./src/assets/images/index/map/zx4.png",
	"./zx5.png": "./src/assets/images/index/map/zx5.png",
	"./zx6.png": "./src/assets/images/index/map/zx6.png",
	"./zx7.png": "./src/assets/images/index/map/zx7.png",
	"./zx8.png": "./src/assets/images/index/map/zx8.png",
	"./zx9.png": "./src/assets/images/index/map/zx9.png",
	"./zx_zhu.png": "./src/assets/images/index/map/zx_zhu.png",
	"./zx_zhu1.png": "./src/assets/images/index/map/zx_zhu1.png",
	"./zx_zhu2.png": "./src/assets/images/index/map/zx_zhu2.png",
	"./zxd.png": "./src/assets/images/index/map/zxd.png",
	"./南美白对虾全产业链.png": "./src/assets/images/index/map/南美白对虾全产业链.png",
	"./卜蜂莲花超市.png": "./src/assets/images/index/map/卜蜂莲花超市.png",
	"./正大优鲜.png": "./src/assets/images/index/map/正大优鲜.png",
	"./正大食品.png": "./src/assets/images/index/map/正大食品.png",
	"./生猪全产业链.png": "./src/assets/images/index/map/生猪全产业链.png",
	"./鸡肉全产业链.png": "./src/assets/images/index/map/鸡肉全产业链.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/index/map sync recursive ^\\.\\/.*$";